
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPastPositionIec as ObiPastPositionIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-past-position-iec.js';
 
 
 

 
 export const ObiPastPositionIec = createComponent({
   react: React,
   tagName: 'obi-past-position-iec',
   elementClass: ObiPastPositionIecElement,
   events: {
     
   }
  });
 
 